// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"474ea06f","488":"5dc00adb","519":"d6029f14","696":"8802f7b2","794":"0de85ead"}[chunkId] + ".chunk.js";
};